module.exports = __webpack_public_path__ + "img/dappradar.d8e0684d.svg";